export default __webpack_public_path__ + "static/media/art-pro-slt-banner-1.315431c9.jpg";